import { render, staticRenderFns } from "./SecondaryChildNavItem.vue?vue&type=template&id=1a2fcb38&scoped=true&"
import script from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryChildNavItem.vue?vue&type=style&index=0&id=1a2fcb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fcb38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2fcb38')) {
      api.createRecord('1a2fcb38', component.options)
    } else {
      api.reload('1a2fcb38', component.options)
    }
    module.hot.accept("./SecondaryChildNavItem.vue?vue&type=template&id=1a2fcb38&scoped=true&", function () {
      api.rerender('1a2fcb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/SecondaryChildNavItem.vue"
export default component.exports